export default function getAppVersion(PUBLIC_CONSTANTS: app.PublicConstants) {
    return `${process.env.BROWSER ? 'browser' : 'server'}-${
        PUBLIC_CONSTANTS.RELEASE_SHORT_TAG}`;
}
